import React, { useState } from "react";
import CalculatorCard from "../../components/CalculatorCard";
import PageSeo from "../../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function OnRoadPriceCalculator() {
  const [exShowroom, setExShowroom] = useState("");
  const [rtoPercent, setRtoPercent] = useState("10");
  const [insurance, setInsurance] = useState("");
  const [accessories, setAccessories] = useState("");
  const [result, setResult] = useState(null);

  const calculateOnRoad = () => {
    const base = Number(exShowroom);
    const rto = (base * Number(rtoPercent || 0)) / 100;
    const insuranceCost = Number(insurance || 0);
    const accessoriesCost = Number(accessories || 0);

    const total = base + rto + insuranceCost + accessoriesCost;

    setResult({
      rto: Math.round(rto),
      total: Math.round(total),
    });
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: On-Road Price ₹ ${result.total} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <Helmet>
        <title>Bike On-Road Price Calculator India | Final Cost | MotoHub India</title>
        <meta
          name="description"
          content="Calculate bike on-road price in India. Estimate RTO, insurance, and total motorcycle cost using MotoHub India calculator."
        />
        <meta
          name="keywords"
          content="bike on road price calculator India, motorcycle price India, ex showroom to on road price bike, bike RTO calculator"
        />
        <link rel="canonical" href="https://motohubindia.com/calculator/onroad" />
        <meta property="og:title" content="Bike On-Road Price Calculator | MotoHub India" />
        <meta property="og:description" content="Estimate total bike cost including RTO and insurance." />
        <meta property="og:url" content="https://motohubindia.com/calculator/onroad" />
      </Helmet>

      <div style={{ padding: "30px" }}>
        <PageSeo
          title="Bike On-Road Price Calculator India | MotoHub"
          description="Estimate final bike cost including RTO and insurance."
          path="/calculator/onroad"
        />

        <CalculatorCard title="On-Road Price Calculator">
          <div style={seoBox}>
            <h2>Bike On-Road Price Calculator India</h2>
            <p style={seoText}>
              Use MotoHub India on-road price calculator to estimate the final cost of your motorcycle. 
              This includes RTO charges, insurance cost, and additional accessories.
            </p>
            <p style={seoText}>
              This tool helps you understand the actual amount you will pay when buying a bike, 
              beyond just the ex-showroom price.
            </p>
          </div>

          <input
            placeholder="Ex-showroom price (Rs)"
            value={exShowroom}
            onChange={(e) => setExShowroom(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="RTO / road tax (%)"
            value={rtoPercent}
            onChange={(e) => setRtoPercent(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Insurance cost (Rs)"
            value={insurance}
            onChange={(e) => setInsurance(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Accessories / handling (Rs)"
            value={accessories}
            onChange={(e) => setAccessories(e.target.value)}
            style={inputStyle}
          />

          <button style={buttonStyle} onClick={calculateOnRoad}>
            Calculate On-Road Price
          </button>

          <div id="calculator-result">
            {result && (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  Estimated RTO: ₹ {result.rto.toLocaleString("en-IN")}
                </h3>
                <h3 style={{ marginTop: "10px" }}>
                  Estimated On-Road Price: ₹ {result.total.toLocaleString("en-IN")}
                </h3>
                <button onClick={shareOnWhatsApp} 
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
                  Share on WhatsApp
                </button>
                <button onClick={downloadPDF}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                  Download PDF
                </button>
              </>
            )}
          </div>
        </CalculatorCard>
      </div>
    </>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #333",
  background: "#1a1a1a",
  color: "#fff",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(90deg, #ff4d00, #ff7a00)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

const seoBox = {
  marginBottom: "20px",
  background: "#111",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #222",
};

const seoText = {
  color: "#aaa",
  lineHeight: "1.6",
  marginTop: "8px",
};